DrawerEventEmitter = function () {};
heir.inherit(DrawerEventEmitter, AppEventEmitter);
// noinspection JSCheckFunctionSignatures
DrawerEventEmitter.prototype.addListener = function (name, action, listener) {
    AppEventEmitter.prototype.addListener.call(this, (name + '.' + action), listener);
};
// noinspection JSCheckFunctionSignatures
DrawerEventEmitter.prototype.emitEvent = function (name, action, args) {
    args = args || {};
    args.name = name;
    AppEventEmitter.prototype.emitEvent.call(this, ('*' + '.' + action), [ args ]);
    if ('*' !== name) {
        AppEventEmitter.prototype.emitEvent.call(this, (name + '.' + action), [ args ]);
    }
};

var initDrawer = function ({ name, selectorTarget, selectorTrigger, openCallback, closeCallback }) {
    var settings = {
        speedOpen: 50,
        speedClose: 350,
        activeClass: 'is-active',
        visibleClass: 'is-visible',
        selectorTarget: selectorTarget || '[data-drawer-target]',
        selectorTrigger: selectorTrigger || '[data-drawer-trigger]',
        selectorClose: '[data-drawer-close]',
    };

    var toggleAccessibility = function (event) {
        if (event.getAttribute('aria-expanded') === 'true') {
            event.setAttribute('aria-expanded', false);
        } else {
            event.setAttribute('aria-expanded', true);
        }
    };

    var openDrawer = function (trigger) {
        var target = document.getElementById(trigger.getAttribute('aria-controls'));
        target.setAttribute('data-name', name);
        target.classList.add(settings.activeClass);

        toggleAccessibility(trigger);
        setTimeout(function () {
            target.classList.add(settings.visibleClass);
            if (typeof openCallback === 'function') {
                openCallback(trigger);
            }
        }, settings.speedOpen);

        if (!$(document.body).hasClass('drawer-open')) {
            $('html, header').css('padding-right', window.innerWidth - document.documentElement.clientWidth);
            document.documentElement.style.overflow = 'hidden';
            document.body.style.overflow = 'hidden';

            var $navbar = $('.navbar-custom');
            $navbar.css('padding-right', 'calc(' + $navbar.css('padding-right') + ' + var(--scrollbar-width))');
        }

        var drawers = $(document.body).data('drawers') || [];
        drawers.push(name);
        $(document.body).addClass('drawer-open').data('drawers', drawers);
    };

    var closeDrawer = function (event) {
        var closestParent = event.closest(settings.selectorTarget),
            childrenTrigger = document.querySelector('[aria-controls="' + closestParent.id + '"');
        closestParent.classList.remove(settings.visibleClass);

        toggleAccessibility(childrenTrigger);
        setTimeout(function () {
            closestParent.classList.remove(settings.activeClass);
            if (typeof closeCallback === 'function') {
                closeCallback(event);
            }
        }, settings.speedClose);

        var drawers = $(document.body).data('drawers') || [];
        drawers.pop();
        $(document.body).toggleClass('drawer-open', !!drawers.length).data('drawers', drawers);

        if (!drawers.length) {
            $('html, header').css('padding-right', '');
            document.documentElement.style.overflow = '';
            document.body.style.overflow = '';

            var $navbar = $('.navbar-custom');
            $navbar.css('padding-right', '24px');
        }
    };

    var clickOpenHandler = function (event) {
        openDrawer(event.target.closest(settings.selectorTrigger));
        event.preventDefault();
    }

    var clickCloseHandler = function (event) {
        closeDrawer(event.target.closest(settings.selectorClose));
        event.preventDefault();
    }

    var keydownHandler = function (event) {
        if (event.key === 'Escape' || event.keyCode === 27) {
            // If a modal was closed by an escape key, keep this drawer open.
            if ($('body').hasClass('modal-closed')) {
                return;
            }
            var drawers = document.querySelectorAll(settings.selectorTarget), i;
            var latest = $(document.body).data('drawers').slice(-1)[0];
            for (i = 0; i < drawers.length; ++i) {
                if (latest && latest !== drawers[i].getAttribute('data-name')) {
                    continue;
                }
                if (drawers[i].classList.contains(settings.activeClass)) {
                    closeDrawer(drawers[i]);
                }
            }
        }
    };

    var openSelector = settings.selectorTrigger + '[aria-controls="' + settings.selectorTarget.replace(/^#/, '') + '"]';
    var closeSelector = settings.selectorTarget + ' ' + settings.selectorClose;

    $(document)
        .on('click', openSelector, clickOpenHandler)
        .on('click', closeSelector, clickCloseHandler)
        .on('keydown', keydownHandler);
};

app.drawer = new DrawerEventEmitter();
app.drawer.INIT = 'init';

app.drawer.on('*', app.drawer.INIT, function (drawer) {
    initDrawer(drawer);
});
